/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import {
  deprecatedVehiclePurchaseInformation,
  DeprecatedVehiclePurchaseInformation$Params
} from '../fn/vehicles/deprecated-vehicle-purchase-information';
import { healVehicle, HealVehicle$Params } from '../fn/vehicles/heal-vehicle';
import { initialVehicle, InitialVehicle$Params } from '../fn/vehicles/initial-vehicle';
import { initialVehicleId, InitialVehicleId$Params } from '../fn/vehicles/initial-vehicle-id';
import { vehicle, Vehicle$Params } from '../fn/vehicles/vehicle';
import {
  vehiclePurchaseInformation,
  VehiclePurchaseInformation$Params
} from '../fn/vehicles/vehicle-purchase-information';
import { vehicleSummary, VehicleSummary$Params } from '../fn/vehicles/vehicle-summary';
import { HealedVehicle } from '../models/healed-vehicle';
import { PurchaseInformation } from '../models/purchase-information';
import { Vehicle } from '../models/vehicle';
import { VehicleIdResponse } from '../models/vehicle-id-response';
import { VehicleSummary } from '../models/vehicle-summary';
import { StrictHttpResponse } from '../strict-http-response';

/**
 * Get vehicle information
 */
@Injectable({ providedIn: 'root' })
export class VehiclesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vehicle()` */
  static readonly VehiclePath = '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}';

  /**
   * Get vehicle for vehicle-id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  vehicle$Response(params: Vehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<Vehicle>> {
    return vehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Get vehicle for vehicle-id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vehicle(params: Vehicle$Params, context?: HttpContext): Observable<Vehicle> {
    return this.vehicle$Response(params, context).pipe(map((r: StrictHttpResponse<Vehicle>): Vehicle => r.body));
  }

  /** Path part for operation `vehicleSummary()` */
  static readonly VehicleSummaryPath = '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/summary';

  /**
   * Get summary details for vehicle-id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehicleSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  vehicleSummary$Response(
    params: VehicleSummary$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<VehicleSummary>> {
    return vehicleSummary(this.http, this.rootUrl, params, context);
  }

  /**
   * Get summary details for vehicle-id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehicleSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vehicleSummary(params: VehicleSummary$Params, context?: HttpContext): Observable<VehicleSummary> {
    return this.vehicleSummary$Response(params, context).pipe(
      map((r: StrictHttpResponse<VehicleSummary>): VehicleSummary => r.body)
    );
  }

  /** Path part for operation `deprecatedVehiclePurchaseInformation()` */
  static readonly DeprecatedVehiclePurchaseInformationPath =
    '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/purchase-information';

  /**
   * Get purchasing information, such as discounted price and legal documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deprecatedVehiclePurchaseInformation()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  deprecatedVehiclePurchaseInformation$Response(
    params: DeprecatedVehiclePurchaseInformation$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<PurchaseInformation>> {
    return deprecatedVehiclePurchaseInformation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get purchasing information, such as discounted price and legal documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deprecatedVehiclePurchaseInformation$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  deprecatedVehiclePurchaseInformation(
    params: DeprecatedVehiclePurchaseInformation$Params,
    context?: HttpContext
  ): Observable<PurchaseInformation> {
    return this.deprecatedVehiclePurchaseInformation$Response(params, context).pipe(
      map((r: StrictHttpResponse<PurchaseInformation>): PurchaseInformation => r.body)
    );
  }

  /** Path part for operation `vehiclePurchaseInformation()` */
  static readonly VehiclePurchaseInformationPath =
    '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/purchase-information/{businessContext}';

  /**
   * Get purchasing information, such as discounted price and legal documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vehiclePurchaseInformation()` instead.
   *
   * This method doesn't expect any request body.
   */
  vehiclePurchaseInformation$Response(
    params: VehiclePurchaseInformation$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<PurchaseInformation>> {
    return vehiclePurchaseInformation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get purchasing information, such as discounted price and legal documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vehiclePurchaseInformation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vehiclePurchaseInformation(
    params: VehiclePurchaseInformation$Params,
    context?: HttpContext
  ): Observable<PurchaseInformation> {
    return this.vehiclePurchaseInformation$Response(params, context).pipe(
      map((r: StrictHttpResponse<PurchaseInformation>): PurchaseInformation => r.body)
    );
  }

  /** Path part for operation `healVehicle()` */
  static readonly HealVehiclePath = '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/{vehicleId}/heal';

  /**
   * Get healed vehicle for vehicle-id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `healVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  healVehicle$Response(
    params: HealVehicle$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<HealedVehicle>> {
    return healVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Get healed vehicle for vehicle-id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `healVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  healVehicle(params: HealVehicle$Params, context?: HttpContext): Observable<HealedVehicle> {
    return this.healVehicle$Response(params, context).pipe(
      map((r: StrictHttpResponse<HealedVehicle>): HealedVehicle => r.body)
    );
  }

  /** Path part for operation `initialVehicleId()` */
  static readonly InitialVehicleIdPath = '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/initialID/{modelId}';

  /**
   * Get initial VehicleId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `initialVehicleId()` instead.
   *
   * This method doesn't expect any request body.
   */
  initialVehicleId$Response(
    params: InitialVehicleId$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<VehicleIdResponse>> {
    return initialVehicleId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get initial VehicleId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `initialVehicleId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  initialVehicleId(params: InitialVehicleId$Params, context?: HttpContext): Observable<VehicleIdResponse> {
    return this.initialVehicleId$Response(params, context).pipe(
      map((r: StrictHttpResponse<VehicleIdResponse>): VehicleIdResponse => r.body)
    );
  }

  /** Path part for operation `initialVehicle()` */
  static readonly InitialVehiclePath = '/api/v3/{market}/{subProcess}/{dataVersion}/vehicles/initial/{bm7_nst}';

  /**
   * Get initial vehicle.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `initialVehicle()` instead.
   *
   * This method doesn't expect any request body.
   */
  initialVehicle$Response(
    params: InitialVehicle$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Vehicle>> {
    return initialVehicle(this.http, this.rootUrl, params, context);
  }

  /**
   * Get initial vehicle.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `initialVehicle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  initialVehicle(params: InitialVehicle$Params, context?: HttpContext): Observable<Vehicle> {
    return this.initialVehicle$Response(params, context).pipe(map((r: StrictHttpResponse<Vehicle>): Vehicle => r.body));
  }
}
